import React, { useState, useEffect, useCallback } from 'react';
import { StyleSheet } from 'react-native';

interface ResetUserPasswordPopupProps {
    onClose: () => void;
    onSave: (text: string) => void;
}


const ResetUserPasswordPopup: React.FC<ResetUserPasswordPopupProps> = ({ onClose, onSave }) => {
    const passowrdsMatch = () => password === confirmPassword;
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showError, setshowError] = useState(passowrdsMatch());
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    const passwordsMatch = useCallback(() => password === confirmPassword, [password, confirmPassword]);
    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    useEffect(() => {
        setshowError(!passwordsMatch());
    }, [passwordsMatch]);


    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(e.target.value);
    };

    const handleSaveChanges = () => {
        if (passowrdsMatch()) {
            onSave(password);
        }
        else {
            setshowError(true)
        }
    };

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1001,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        input: {
            shadowOpacity: 0,
            borderRadius: 8,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#D0D5DD',
            height: 35
        }
    });
    

    return (
        <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-between'>
                <h5>Reset User Password</h5>
            </div>
            <div className='px-3 pb-3 d-flex flex-column'>
                <label className='mt-3 mb-1'>New Password</label>
                <input
                    type="password"
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Enter new password"
                    style={styles.input}
                />
                <label className='mt-3 mb-1'>Confirm Password</label>
                <input
                    type="password"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    placeholder="Confirm new password"
                    style={styles.input}
                />
                {
                    showError &&
                    <small style={{ color: '#F04438', marginLeft: 2 }}>
                        Passwords do not match
                    </small>
                }
                <div className='d-flex mt-4 align-items-center justify-content-end' style={{ gap: '10px', flexWrap: 'nowrap' }}>
                    <button className='blue-outline-btn align-items-center d-flex w-100' onClick={onClose} style={{borderRadius: 8}}>
                        Cancel
                    </button>
                    <button className='blue-filled-btn align-items-center d-flex w-100' onClick={handleSaveChanges} style={{borderRadius: 8}}>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};



export default ResetUserPasswordPopup;

